module.exports = {
      id: "edited-by-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#edited-by",
      toString: function () {
        return this.url;
      }
    }